"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeSwing = void 0;
const CTGGameModeFlappy_1 = require("./CTGGameModeFlappy");
class CTGGameModeSwing extends CTGGameModeFlappy_1.CTGGameModeFlappy {
    constructor(generator, speed) {
        super(generator, speed);
    }
    reset() {
        super.reset();
        this.gravity_down = true;
    }
    clicked(scene, mx, my) {
        this.gravity_down = !this.gravity_down;
        scene.add_sound_to_set("sfx_destroy");
    }
    update_position(now, delta, difficulty, mx, my, mdown) {
        const delta_s = delta / 1000;
        this.bird_vel += this.gravity * (this.gravity_down ? 1 : -1) * delta_s * (1 + this.difficulty);
        this.bird.move(this.bird.x, this.bird.y + this.bird_vel * delta_s * (1 + this.difficulty));
    }
}
exports.CTGGameModeSwing = CTGGameModeSwing;
